/**
 * Khối section trong form admin — tiêu đề, mô tả và lưới field con.
 */

/**
 * Section form admin.
 * @param {Object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {React.ReactNode} props.children
 */
export const AdminFormSection = ({ title, description, children }) => (
  <section className="form-section">
    <div className="form-section-header">
      <h3 className="form-section-title">{title}</h3>
      {description && <p className="form-section-desc">{description}</p>}
    </div>
    <div className="form-grid">{children}</div>
  </section>
);
